<template>
	<div class="subscription">
		<div v-if="objectOrder != null">
			<div class="">
				<span class="fs-5">{{ typeOrder }} Nº {{ objectOrder.id }}</span>
				<span class="fs-6 float-end">Estado <span :class="'badge text-bg-' + objectOrder.color">{{ objectOrder.status }}</span></span>
			</div>
			<div class="mt-1">
				<div class="row text-secondary">
					<div class="col-md-8">
						<div class="card rounded-0 mb-2">
							<div class="card-body">
								<div class="table-responsive">
									<table class="table table-sm table-hover text-secondary">
										<thead>
											<tr>
												<th class="text-center">Producto</th>
												<th class="text-center">Precio</th>
												<th class="text-center">Cantidad</th>
												<th class="text-center">Total</th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(item, index) in objectOrder.order_products" :key="index">
												<td :title="'Codigo: ' + item.product_id">{{ item.product }}</td>
												<td class="text-end">{{ item.price | formatNumber }}</td>
												<td class="text-end">{{ item.quantity | formatNumber }}</td>
												<td class="text-end">{{ (item.quantity * item.price) | formatNumber }}</td>
											</tr>
										</tbody>
										<tfoot>
											<tr class="fw-bold">
												<td class="text-end" colspan="3">TOTAL: </td>
												<td class="text-end">{{ objectOrder.total | formatNumber }}</td>
											</tr>
										</tfoot>
									</table>
								</div>
								<b>* Todos los envíos son trimestrales, incluso las revistas mensuales</b>
							</div>
						</div>
						<div v-if="objectOrder.type_order_id == 3">
							<div class="card rounded-0 mb-2">
								<div class="card-body">
									<div class="fw-semibold fs-6 mb-1">Formas de pago:</div>
									<div class="row" v-if="objectOrder.status_id == 30">
										<div class="col-md-6 text-center">
											<svg class="bi text-info flex-shrink-0" width="48" height="48"><use xlink:href="#credit-card"/></svg>
											<div>
												<h5 class="mb-1">Pago en línea</h5>
												<span @click="paymentType = 'transbank'">
													<transbank :amount="objectOrder.total" :orderTokens="[objectOrder.token]" ref="transbank" @actionAfterGetToken="actionAfterGetTokenLocal"></transbank>
												</span>
											</div>
										</div>
										<div class="col-md-6 text-center">
											<svg class="bi text-primary flex-shrink-0" width="48" height="48"><use xlink:href="#bank"/></svg>
											<div class="flex-fill">
												<h5 class="mb-1">Transferencia o Depósito:</h5>
												<button class="btn btn-primary" @click="showPaymentOrderModalLocal">Pagar con transferencia</button>
											</div>											
										</div>
									</div>
									<div v-else>
										<div class="table-responsive">
											<table class="table table-sm">
												<thead>
													<tr>
														<th class="text-center">Tipo de Pago</th>
														<th class="text-center">Monto</th>
														<th class="text-center">Banco</th>
														<th class="text-center">Codigo</th>
														<th class="text-center">Observación</th>
														<th class="text-center">Fecha Movimiento</th>
														<th class="text-center">Estado</th>
													</tr>
												</thead>
												<tbody>
													<tr v-for="(item, index) in objectOrder.payments" :key="index">
														<td>{{item.typePayment}}</td>
														<td class="text-end">{{item.amount | formatNumber}}</td>
														<td class="text-center">{{item.bank}}</td>
														<td class="text-center">{{item.code}}</td>
														<td>{{item.description}}</td>
														<td class="text-center">{{item.transaction_date}}</td>
														<td class="text-center">
															<span class="badge " :class="'text-bg-' + item.color">{{item.status}}</span></td>
													</tr>
												</tbody>
											</table>
										</div>
									</div>
								</div>
							</div>
							<div class="card rounded-0 mb-2" v-if="paymentType == 'transfer' && objectOrder.status_id == 30">
								<div class="card-body">
									<div class="fw-semibold fs-6 mb-1">Datos de transferencia:</div>
									<div class="row">
										<div class="col-md-6">
											<div class="flex-fill">
												Los datos para transferir o hacer un depósito son los siguientes:

												<p>Nombre <span class="fw-semibold text-institutional">Corporación Iglesia Adventista del Séptimo Día</span></p>
												<span>Banco Estado</span>
												<ul>
													<li>Cuenta N° <span class="fw-semibold text-institutional">33400004345</span></li>
													<li>RUT <span class="fw-semibold text-institutional">82.745.300-5</span></li>
												</ul>
												<span>Banco BCI</span>
												<ul>
													<li>Cuenta N° <span class="fw-semibold text-institutional">32306601</span></li>
													<li>RUT <span class="fw-semibold text-institutional">82.745.300-5</span></li>
												</ul>
												<ul>
													<li>Correo <span class="fw-semibold text-institutional">pedidos@aceschile.cl</span></li>
													<li>Comentario <span class="fw-semibold text-institutional">Suscripciones {{buyOrder}}</span></li>
												</ul>
												<br>
												<span>MONTO: $ <span class="fw-semibold text-institutional">{{ objectOrder.total | formatNumber }}</span></span>
												<br>
											</div>
										</div>
										<div class="col-md-6 text-center pointer" style="min-height: 100px">
											<span v-if="getClientSystem.id == objectOrder.client_id && objectOrder.status_id == 30 && objectOrder.upload_documents.length == 0">
												<label for="formFileSm" class="form-label pointer text-white bg-info px-3 py-2 border border-info rounded-3" style="font-size:16px">
													Subir Comprobante
													<svg class="" width="14" height="14">
														<use xlink:href="#upload"/>
													</svg>
												</label>
												<input class="form-control form-control-sm" id="formFileSm" type="file" v-show="false" accept=".png, .jpg, .jpeg" @change="loadDocument">
											</span>
											<div v-if="objectOrder.upload_documents.length > 0">
												<div class="col-sm-12" v-for="(item, index) in objectOrder.upload_documents" :key="index">
													<div class="card rounded-0 mb-1 title-width-icon text-center">
														<div class="icon position-absolute text-end" style="width: 100%"
															v-if="getClientSystem.id == objectOrder.client_id && objectOrder.status_id == 30 && item.user_id == 0">
															<svg class="text-danger me-2" width="16" height="16" @click="showConfirmDeleteUploadDocument(item)"><use xlink:href="#trash3"/></svg>
														</div>
														<div class="card-body">
															<img :src="item.public_path + item.name_save" style="width: 100%"/>
															<span class="pointer text-primary text-decoration-underline">{{ item.name_original }}</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="card rounded-0 mb-2" v-if="objectOrder.status_id != 30">
								<div class="card-body">
									<div class="fw-semibold fs-6">
										<span v-if="getClientSystem.id == objectOrder.client_id && objectOrder.status_id == 30" class="float-end">
											<label for="formFileSm" class="form-label pointer text-info" style="font-size: 12px">
												Subir Archivo
												<svg class="" width="14" height="14">
													<use xlink:href="#upload"/>
												</svg>
											</label>
											<input class="form-control form-control-sm" id="formFileSm" type="file" v-show="false" accept=".png, .jpg, .jpeg" @change="loadDocument">
										</span>
										<span>Archivos adjuntos:</span>
										<div class="row">
											<div class="col-sm-6 col-md-4" v-for="(item, index) in objectOrder.upload_documents" :key="index">
												<div class="card rounded-0 mb-1 title-width-icon text-center">
													<div class="icon position-absolute text-end" style="width: 100%"
														v-if="getClientSystem.id == objectOrder.client_id && objectOrder.status_id == 30 && item.user_id == 0">
														<svg class="text-danger me-2" width="16" height="16" @click="showConfirmDeleteUploadDocument(item)"><use xlink:href="#trash3"/></svg>
													</div>
													<div class="card-body">
														<img :src="item.public_path + item.name_save" style="width: 100%"/>
														<span class="pointer text-primary text-decoration-underline">{{ item.name_original }}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div class="card rounded-0 mb-2" v-if="objectOrder.legal_documents.length > 0">
								<div class="card-body">
									<div class="fw-semibold fs-6 mb-1">Documentos Electronicos ({{ objectOrder.legal_documents.length }}):</div>
									<div class="table-responsive">
										<table class="table table-sm table-hover">
											<thead>
												<tr class="text-center">
													<th>Tipo de Documento</th>
													<th>Folio</th>
													<th>Fecha</th>
													<th>Monto</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item, index) in objectOrder.legal_documents" :key="index">
													<td class="text-center">{{ item.type_legal_document }}</td>
													<td class="text-center">{{ item.legal_document_number }}</td>
													<td class="text-center">{{ item.date_legal_document }}</td>
													<td class="text-end">{{ item.total | formatNumber }}</td>
													<td class="text-end text-info pointer" :title="'Descargar ' + item.type_legal_document + ' Numero '+ item.legal_document_number">
														<a :href="item.url" download>
															<i class="fas fa-download"></i>
														</a>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
						<div>
							<div class="card rounded-0 mb-2" v-if="listSubscriptionDetails.length > 0">
								<div class="card-body">
									<div class="fw-semibold fs-6 mb-1">Detalle Envío de Suscripción ({{ listSubscriptionDetails.length }}):</div>
									<div class="table-responsive">
										<table class="table table-sm table-hover">
											<thead>
												<tr class="text-center">
													<th>ID</th>
													<th>Pertenece a</th>
													<th>Fecha</th>
													<th>Estado</th>
													<th>Items</th>
												</tr>
											</thead>
											<tbody>
												<tr v-for="(item, index) in listSubscriptionDetails" :key="index">
													<td class="text-center">{{ item.id }}</td>
													<td>{{ item.client_sendto.sendto }}</td>
													<td class="text-center">{{ item.created_at }}</td>
													<td class="text-center">
														<span :class="'badge text-bg-' + item.color">{{ item.status }}</span>
													</td>
													<td class="text-center">{{ item.order_products.length }}</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="col-md-4">
						<div class="card rounded-0 mb-2">
							<div class="card-body">
								<div class="fw-semibold fs-6">Cargado a:</div>
								<div>
									<svg class="text-secondary me-1" width="14" height="14"><use xlink:href="#person-badge"/></svg>
									<span class="fw-semibold align-middle text-secondary">{{ objectOrder.client_sendto.sendto }}</span>
								</div>
								<div>
									<svg class="text-secondary me-1" width="14" height="14"><use xlink:href="#envelope"/></svg>
									<span class="fw-semibold align-middle text-secondary">{{ objectOrder.client_sendto.email }}</span>
								</div>
								<div>
									<svg class="text-secondary me-1" width="14" height="14"><use xlink:href="#phone"/></svg>
									<span class="fw-semibold align-middle text-secondary">{{ objectOrder.client_sendto.phone }}</span>
								</div>

								<div class="list-group-light p-0">
									<div class="list-group-item d-flex justify-content-between align-items-center">
										<div>
											<div class="fw-semibold align-middle text-secondary">
												<svg class="text-secondary me-1" width="14" height="14"><use xlink:href="#building"/></svg>
												{{ objectOrder.church.type_church.name }} {{ objectOrder.church.name }}
											</div>
											<div class="ms-4 text-secondary">Distrito: {{ objectOrder.church.district.name }} ({{ objectOrder.church.entity.synthetic }})</div>
											<p class="ms-4" v-if="getClientSystem.id != objectOrder.church.client_id">
												<span class="text-muted" v-if="objectOrder.church.client_id != undefined && objectOrder.church.client_id != null">
													CPIL: {{ objectOrder.church.client.name }} {{ objectOrder.church.client.surname }}
												</span>
												<span class="text-danger" v-else>
													Esta Iglesia no tiene un CPIL asignado
												</span>
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div v-if="objectOrder.status_id == 30 && getClientSystem.id == objectOrder.client_id" class="d-grid gap-2">
							<button class="btn btn-danger" type="button" @click="deleteSubscriptionLocal" :disabled="erasingSubscription">Borrar Suscripción</button>
						</div>
					</div>
				</div>
			</div>
			<div class="text-end">
				<small class="text-muted">Creado: {{ objectOrder.created_at }}</small>
			</div>
		</div>

		<confirm ref="confirmDeleteUploadDocument" title="Confirmación para borrar Documento" @actionYes="deleteUploadDocumentLocal" :msg="msgDeleteUploadDocument"  :data="dataDeleteUploadDocument"></confirm>

		<div class="modal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" id="paymentOrderModal">
			<div class="modal-dialog">
    			<div class="modal-content rounded-2">
			    	<div class="modal-body p-4">
						<h3 class="fw-bold mb-0">Pagar Suscripciones</h3>
						<ul class="d-grid gap-4 my-3 list-unstyled">
							<li class="d-flex gap-4 border p-3">
								<svg class="bi text-primary flex-shrink-0" width="48" height="48"><use xlink:href="#bank"/></svg>
								<div class="flex-fill">
									<h5 class="mb-0">Transferencia o Depósito:</h5>
									Los datos para transferir o hacer un depósito son los siguientes:

									<p>Nombre <span class="fw-semibold text-institutional">Corporación Iglesia Adventista del Séptimo Día</span></p>
									<span>Banco Estado</span>
									<ul>
										<li>Cuenta N° <span class="fw-semibold text-institutional">33400004345</span></li>
										<li>RUT <span class="fw-semibold text-institutional">82.745.300-5</span></li>
									</ul>
									<span>Banco BCI</span>
									<ul>
										<li>Cuenta N° <span class="fw-semibold text-institutional">32306601</span></li>
										<li>RUT <span class="fw-semibold text-institutional">82.745.300-5</span></li>
									</ul>
									<ul>
										<li>Correo <span class="fw-semibold text-institutional">pedidos@aceschile.cl</span></li>
										<li>Comentario <span class="fw-semibold text-institutional">Suscripciones {{buyOrder}}</span></li>
									</ul>
									<br>
									<span>MONTO: $ <span class="fw-semibold text-institutional">{{ objectOrder.total | formatNumber }}</span></span>
									<br>
								</div>
							</li>
							<li class="p-3 text-center">
								<span v-if="getClientSystem.id == objectOrder.client_id && objectOrder.status_id == 30 && objectOrder.upload_documents.length == 0">
									<label for="formFileSm" class="form-label pointer text-muted" style="font-size:16px">
										Subir Comprobante
										<svg class="" width="14" height="14">
											<use xlink:href="#upload"/>
										</svg>
									</label>
									<input class="form-control form-control-sm" id="formFileSm" type="file" v-show="false" accept=".png, .jpg, .jpeg" @change="loadDocument">
								</span>
								<div v-if="objectOrder.upload_documents.length > 0">
									<div class="col-sm-12" v-for="(item, index) in objectOrder.upload_documents" :key="index">
										<div class="card rounded-0 mb-1 title-width-icon text-center">
											<div class="icon position-absolute text-end" style="width: 100%"
												v-if="getClientSystem.id == objectOrder.client_id && objectOrder.status_id == 30 && item.user_id == 0">
												<svg class="text-danger me-2" width="16" height="16" @click="showConfirmDeleteUploadDocument(item)"><use xlink:href="#trash3"/></svg>
											</div>
											<div class="card-body">
												<img :src="item.public_path + item.name_save" style="width: 100%"/>
												<span class="pointer text-primary text-decoration-underline">{{ item.name_original }}</span>
											</div>
										</div>
									</div>
								</div>
							</li>
						</ul>
						<div class="text-center">
							<button type="button" class="btn btn-lg btn-secondary mt-2" data-bs-dismiss="modal">Cerrar</button>
						</div>
					</div>
				</div>
			</div>
		</div>
		<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#paymentOrderModal" ref="btnShowPaymentOrderModal" v-show="false">
  			Abrir Modulo de Pago
		</button>


		<div class="modal modal-sheet py-5" tabindex="-1" role="dialog" id="loadDocumentDoneModal">
			<div class="modal-dialog" role="document">
				<div class="modal-content rounded-4 shadow">
					<div class="modal-header border-bottom-0">
						<h5 class="modal-title">Proceso Terminado</h5>
						<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
					</div>
					<div class="modal-body py-0">
						<p>Gracias por subir el comprobante.</p>
					</div>
					<div class="modal-footer flex-column border-top-0">
						<button type="button" class="btn btn-sm btn-light w-100 mx-0" data-bs-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>
		<button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#loadDocumentDoneModal" ref="btnShowLoadDocumentDoneModal" v-show="false">
  			Abrir Modulo de condfirmación Pago
		</button>
	</div>
</template>

<script>
	import mixin from '@/mixins'
	import axiosAWN from '@/mixins/axiosAWN.js'

	import Confirm from '@/components/ConfirmComponent.vue'
	import Transbank from '@/components/TransbankComponent.vue'
	
	export default {
		name: 'Subscription',
		mixins: [mixin, axiosAWN],
		props: ['token'],
		data() {
			return {
				objectOrder: null,
				searchingSubscription: false,
				erasingSubscription: false,
				dataDeleteUploadDocument: null,
				msgDeleteUploadDocument: '¿Desea eliminar esta imagen?',
				buyOrder: '',
				typeOrder: 'Movimiento',
				listSubscriptionDetails: [],
				paymentType: 'transbank',
				paymentTransfer: 'card'
			}
		},
		components: {
			'confirm': Confirm,
			'transbank': Transbank
		},
		computed: {},
		methods: {
			initModuleLocal() {
				document.title = 'Suscripción - Suscripción ACES Chile'
				this.getSubscription()
			},
			actionAfterGetTokenLocal(data) {
				this.buyOrder = data.buyOrder
			},
			deleteSubscriptionLocal() {
				this.erasingSubscription = true
				let url = this.getApiBackend + 'subscription/' + this.token + '/delete'
				document.title = 'Borrando suscripción ' + this.objectOrder.id + ' . . .'
				this.axiosAWNasyncBlock('Borrando suscripción ' + this.objectOrder.id, 'DELETE', url, 'deleteSubscriptionResult')
			},
			deleteSubscriptionResult(response) {
				if(response.data.success == true) {
					this.$awn.success('Suscripción Borrada')
					this.$router.push('/subscriptions')
				} else {
					this.deleteSubscriptionResultError(response)
				}
			},
			deleteSubscriptionResultError(error) {
				this.erasingSubscription = false
				this.$awn.alert('No se pudo borrar la suscripción')
				console.log(error)
			},
			deleteUploadDocumentLocal(data) {
				this.$refs.confirmDeleteUploadDocument.$refs.closeConfirmModal.click()
				let url = this.getApiBackend + 'subscription/' + data.id + '/deleteUploadDocument'
				document.title = 'Borrando documento ' + data.name_original + ' . . .'
				setTimeout(() => {this.axiosAWNasyncBlock('Borrando documento ' + data.name_original, 'DELETE', url, 'deleteUploadDocumentResult')}, 500)
			},
			deleteUploadDocumentResult(response) {
				document.title = this.typeOrder + ' Nº ' + this.objectOrder.id + ' - Suscripción ACES Chile'
				if(response.data.success == true) {
					let index = this.objectOrder.upload_documents.map((el) => parseInt(el.id)).indexOf(parseInt(response.data.data))
					if(index > -1) {
						this.objectOrder.upload_documents.splice(index, 1)
					}
				} else {
					this.deleteUploadDocumentResultError(response)
				}
			},
			deleteUploadDocumentResultError(error) {
				this.$awn.alert('No se pudo borrar el documento')
				console.log(error)
			},
			getSubscription() {
				this.searchingSubscription = true
				let url = this.getApiBackend + 'subscription/' + this.token
				document.title = 'Buscando Suscripción . . .'
				this.axiosAWNasyncBlock('Buscando Suscripción', 'POST', url, 'getSubscriptionResult')
			},
			getSubscriptionResult(response) {
				if(response.data.success) {
					this.objectOrder = response.data.data
					console.log(this.objectOrder)
					this.typeOrder = this.objectOrder.type_order.name
					document.title = this.typeOrder + ' Nº ' + this.objectOrder.id + ' - Suscripción ACES Chile'
					if(this.objectOrder.type_order_id != 8) {
						this.getSubscriptionShippingDetails()
					}
					if(this.objectOrder.type_order_id == 3 && this.objectOrder.status_id == 30) {
						setTimeout(() => { this.$refs.transbank.$refs.btnConnect.click() }, 500)
					}
				} else {
					this.getSubscriptionResultError(response)
				}
				this.searchingSubscription = false
			},
			getSubscriptionResultError(error) {
				document.title = 'Error - Suscripción ACES Chile'
				this.searchingSubscription = false
				this.$awn.alert('No se pudo recuperar la Suscripción')
				console.log(error)
				this.$router.push('/subscriptions')
			},
			getSubscriptionShippingDetails() {
				console.log('Buscando detalles del envío de suscripción Nº ' + this.objectOrder.id + '...')
				let url = this.getApiBackend + 'subscription/' + this.token + '/details'
				document.title = 'Buscando detalles del envío de suscripción Nº ' + this.objectOrder.id
				this.axiosAWNasyncBlock(document.title, 'POST', url, 'getSubscriptionShippingDetailsResult')
			},
			getSubscriptionShippingDetailsResult(response) {
				document.title = this.typeOrder + ' Nº ' + this.objectOrder.id + ' - Suscripción ACES Chile'
				if(response.data.success) {
					this.listSubscriptionDetails = response.data.data
					console.log('Se encontron ' + this.listSubscriptionDetails.length + ' detalle(s)')
				} else {
					this.getSubscriptionShippingDetailsResultError(response)
				}
			},
			getSubscriptionShippingDetailsResultError(error) {
				document.title = this.typeOrder + ' Nº ' + this.objectOrder.id + ' - Suscripción ACES Chile'
				this.searchingSubscription = false
				this.$awn.alert('No se pudo recuperar los detalles de este envío de suscripción')
			},
			loadDocument(event) {
                let file = event.target.files[0]
                let formData = new FormData();
                formData.append('file', file);
                
				let url = this.getApiBackend + 'subscription/' + this.token + '/uploadDocument/' + this.getClientSystem.id
				document.title = 'Subiendo archivo . . .'
				this.axiosAWNasyncBlock('Subiendo archivo', 'POST', url, 'loadDocumentResult', formData)
            },
			loadDocumentResult(response) {
				document.title = this.typeOrder + ' Nº ' + this.objectOrder.id + ' - Suscripción ACES Chile'
				if(response.data.success == true) {
					this.objectOrder.upload_documents.push(response.data.data)
					this.showLoadDocumentDoneModal()
				} else {
					this.loadDocumentResultError(response)
				}
			},
			loadDocumentResultError(response) {
				document.title = 'Error - Suscripción ACES Chile'
				this.$awn.alert('No se pudo subir el archivo')
				console.log(error)
			},
			showConfirmDeleteUploadDocument(item) {
				this.dataDeleteUploadDocument = item
				this.msgDeleteUploadDocument = '¿Quiere borrar el documento ' + item.name_original + '?'
				setTimeout(() => { this.$refs.confirmDeleteUploadDocument.$refs.showConfirmModal.click() }, 500)
			},
			showLoadDocumentDoneModal() {
				this.$refs.btnShowLoadDocumentDoneModal.click()
			},
			showPaymentOrderModalLocal() {
				if(this.objectOrder.status_id == 30 && this.objectOrder.paid == 0) {
					if(this.paymentTransfer == 'modal') {
						this.$refs.btnShowPaymentOrderModal.click()
					} else {
						this.paymentType = 'transfer'
					}
					/*if(this.buyOrder == '') {
						setTimeout(() => { this.$refs.transbank.$refs.btnConnect.click() }, 500)
					}*/
				}
			}
		},
		mounted () {
			this.initModule()
		}
	}
</script>

<style>
</style>